import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import { APIHandler, DataHandler, Image, SharingPopup, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const trackShare = async (type, val) => {
  const appId = DataHandler.matchAppId();

  StorageHandler.load(storageKeys.user).then((userObj) => {
    console.log(userObj);
    let email = '';
    ({ email } = userObj.response);
    APIHandler.trackEvent(appId, email, 'collateral', type, val).then(() => {});
  });
};

const ImageItem = (props) => {
  const {
    chapterTitle, image, opacity, pageID,
  } = props;
  let { title } = props;
  title = title.replace('&amp;', '&');
  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={image} image={image} title={title} />),
    },
    caption: title,
  };
  return (
    <div className="imageGrid_Card" style={{ opacity }} onClick={() => trackShare('collectionItem', image)}>
      <a 
        href={image} 
        caption={title}
        data-fancybox="images"
        data-type="image"
        data-options={JSON.stringify({
          buttons: ['thumbs', 'share', 'close'],
          share: {
            tpl: renderToString(<SharingPopup url={image} image={image} title={title} />),
          },
        })}
      >
        <Image
          key={pageID.toString()}
          src={image}
          gradient
          href={image}
          fancybox={chapterTitle}
          options={fancyOptions}
          caption={title}        
        />
        <div className="title">{title}</div>
      </a>
    </div>
  );
};

const WebLinkItem = (props) => {
  const {
    image, url,
  } = props;
  let { title } = props;
  title = title.replace('&amp;', '&');
  return (
    <div className="collection_Card" key={url}>
      <a href={url} target="_blank" rel="noopener noreferrer" onClick={() => trackShare('collectionItem', url)}>
        <Image
          key={url}
          src={image}
          gradient
          onLoad={() => { this.setState({ loading: false }); }}
          href={url}
        />
        <div className="title">{title}</div>
      </a>
    </div>
  );
};
const PdfItem = (props) => {
  const {
    image, pageID, url,
  } = props;
  let { title } = props;
  title = title.replace('&amp;', '&');
  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={url} image={image} title={title} />),
    },
    caption: title,
  };
  return (
    <div className="collection_Card" key={pageID} >
      <Image
        key={url}
        src={image}
        gradient        
        onLoad={() => { this.setState({ loading: false }); }}
        href={`https://stack.travpromobile.com/viewer.php?file=${url}`}
        fancybox={`https://stack.travpromobile.com/viewer.php?file=${url}`}
        options={fancyOptions}
        caption={title}
      />
      <div className="title">{title}</div>
    </div>
  );
};
const VideoItem = (props) => {
  const {
    chapterImage, linkJW, opacity, url, image,
  } = props;
  let { thumbnail } = props;
  if (image) {
    thumbnail = image;
  }
  if (!thumbnail) {
    thumbnail = chapterImage;
  }
  let { title } = props;
  title = title.replace('&amp;', '&');

  console.log(thumbnail);
  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={url} image={image} title={title} />),
    },
    caption: title,
  };
  return (
    <div className="videoGrid_Holder">
      <div className="videoGrid_Card" style={{ opacity }}>
        <a 
          href={url} 
          data-options={fancyOptions}
          caption={title}
          data-fancybox
          data-options={JSON.stringify({
            buttons: ['thumbs', 'share', 'close'],
            share: {
              tpl: renderToString(<SharingPopup url={url} image={thumbnail} title={title} />),
            },
          })}
          onClick={() => trackShare('collectionItem', url)}
        >
          <Image
            key={url}          
            src={thumbnail || 'https://via.placeholder.com/350x250?text=Placeholder%20Thumbnail'}
            gradient
            href={url}
            fancybox={url}
            options={fancyOptions}
            caption={title}
          />
          <div className="title">{title}</div>
        </a>
      </div>
    </div>
  );
};

const ItemCollection = (props) => {
  const { chapter, collectionTitle } = props;
  const [{ chapter: firstChapter }] = chapter || [{}];
  const { chapterTitle, chapterNumber, chapterImage } = firstChapter || {};
  const startingValues = Object.keys(chapter).map(() => ({ pos: 0 }));

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={window.location.href} />),
    },
    caption: chapterTitle,
  };

  return (
    <div className="imageGrid__Container">
      {collectionTitle.length === 1 && (
        <div className="imageGrid__Container--title">
          <h3>{chapterTitle}</h3>
        </div>
      )}
      <div className="imageGrid__Container--title">
        <h3>{chapterTitle}</h3>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
            ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
            : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="imageGrid__Grid" key={chapterTitle}>
            {Object.keys(chapter).map((key, index) => {
                const {
                  image, linkJW, pageID, title, type, url, thumbnail,
                } = chapter[key];
                const { pos: opacity } = styles[index] || {};
                const commonProps = {
                  fancyOptions, key, opacity, title,
                };
                const imageObj = {
                  chapterTitle, image, pageID,
                };
                const videoObj = {
                  chapterImage, linkJW, thumbnail, url, image,
                };
                const pdfObj = {
                  chapterTitle, image, pageID, url,
                };
                if (type === 'pdf') {
                  return <PdfItem {...commonProps} {...pdfObj} />;
                }
                if (type === 'weblink') {
                  return <WebLinkItem {...commonProps} {...pdfObj} />;
                }
                return (['photo', 'weblink'].includes(type))
                  ? (<ImageItem {...commonProps} {...imageObj} />)
                  : (<VideoItem {...commonProps} {...videoObj} />);
              })}
          </div>
          )}
      </StaggeredMotion>
    </div>
  );
};

export default ItemCollection;

ItemCollection.propTypes = {
  chapter: PropTypes.arrayOf(PropTypes.shape()),
  collectionTitle: PropTypes.string,
};
ItemCollection.defaultProps = {
  chapter: null,
  collectionTitle: '',
};
ImageItem.propTypes = {
  chapterTitle: PropTypes.string.isRequired,
  image: PropTypes.string,
  opacity: PropTypes.number,
  pageID: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  title: PropTypes.string,
};
ImageItem.defaultProps = {
  image: null,
  opacity: 1,
  title: null,
};
VideoItem.propTypes = {
  chapterImage: PropTypes.string,
  linkJW: PropTypes.string.isRequired,
  opacity: PropTypes.number,
  thumbnail: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string.isRequired,
};
VideoItem.defaultProps = {
  chapterImage: null,
  opacity: 1,
  thumbnail: null,
  image: null,
  title: null,
};
WebLinkItem.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string.isRequired,
};
WebLinkItem.defaultProps = {
  image: null,
  title: null,
};
PdfItem.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
  pageID: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};
PdfItem.defaultProps = {
  image: null,
  title: null,
};
